import React, { useState, useEffect } from "react";
import ConfirmationModal from "../Confirmation Modal/confirmationModal";
import DinarHint from "../ui/DinarHint";

import { t } from "../../i18n";
const UpdateModalForm = ({ isOpen, worker, onClose, onSave }) => {
  const [formData, setFormData] = useState(worker || {});
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");

  useEffect(() => {
    setFormData(worker || {});
  }, [worker]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validData = {
      name: formData.name,
      salary: formData.salary,
      job: formData.job,
      phone: formData.phone,
    };

    // Validate phone number format
    if (!/^[0-9]{10,15}$/.test(validData.phone)) {
      setConfirmationMessage(t("رقم الهاتف غير صحيح. يجب أن يكون من 10 إلى 15 رقمًا."));
      setIsConfirmationOpen(true);
      return;
    }

    onSave(validData);
    setConfirmationMessage(t("تم تحديث معلومات العامل بنجاح!"));
    setIsConfirmationOpen(true);
    onClose();
  };

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-panel md:max-w-[660px]" role="dialog" aria-modal="true">
          {/* Header */}
          <div className="bg-brand-600 text-white text-lg font-semibold px-6 py-4 rounded-t-2xl text-right">
            {t("تحديث معلومات العامل")}
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            {/* Name Field */}
            <div className="flex flex-col-reverse sm:flex-row ltr:sm:flex-row-reverse sm:items-center gap-1.5 sm:gap-4">
              <input
                type="text"
                name="name"
                value={formData.name || ""}
                onChange={handleChange}
                placeholder={t("ادخل الاسم")}
                className="field sm:w-3/4"
              />
              <label className="text-slate-700 text-sm md:text-base font-medium text-right sm:w-1/4">
                {t("الاسم")}
              </label>
            </div>

            {/* Salary Field */}
            <div className="flex flex-col-reverse sm:flex-row ltr:sm:flex-row-reverse sm:items-center gap-1.5 sm:gap-4">
              <div className="sm:w-3/4">
                <input
                  type="number"
                  name="salary"
                  value={formData.salary || ""}
                  onChange={handleChange}
                  placeholder={t("ادخل الراتب")}
                  className="field"
                />
                <DinarHint value={formData.salary} />
              </div>
              <label className="text-slate-700 text-sm md:text-base font-medium text-right sm:w-1/4">
                {t("الراتب (بالألف)")}
              </label>
            </div>

            {/* Job Field */}
            <div className="flex flex-col-reverse sm:flex-row ltr:sm:flex-row-reverse sm:items-center gap-1.5 sm:gap-4">
              <input
                type="text"
                name="job"
                value={formData.job || ""}
                onChange={handleChange}
                placeholder={t("ادخل الوظيفة")}
                className="field sm:w-3/4"
              />
              <label className="text-slate-700 text-sm md:text-base font-medium text-right sm:w-1/4">
                {t("الوظيفة")}
              </label>
            </div>

            {/* Phone Field */}
            <div className="flex flex-col-reverse sm:flex-row ltr:sm:flex-row-reverse sm:items-center gap-1.5 sm:gap-4">
              <input
                type="text"
                name="phone"
                value={formData.phone || ""}
                onChange={handleChange}
                placeholder={t("ادخل رقم الهاتف")}
                className="field sm:w-3/4"
              />
              <label className="text-slate-700 text-sm md:text-base font-medium text-right sm:w-1/4">
                {t("رقم الهاتف")}
              </label>
            </div>
          </form>

          {/* Footer */}
          <div className="bg-slate-50 border-t border-slate-200 flex flex-wrap justify-end px-6 py-4 rounded-b-2xl gap-3">
            <button
              type="button"
              onClick={onClose}
              className="bg-card text-slate-700 border border-slate-300 px-4 py-2 rounded-lg font-medium hover:bg-slate-100"
            >
              {t("إلغاء")}
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              className="bg-brand-600 text-white px-4 py-2 rounded-lg font-medium shadow-sm hover:bg-brand-700 disabled:opacity-60"
            >
              {t("حفظ")}
            </button>
          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      <ConfirmationModal
        isOpen={isConfirmationOpen}
        message={confirmationMessage}
        onConfirm={() => setIsConfirmationOpen(false)}
      />
    </>
  );
};

export default UpdateModalForm;
